(function () {
  'use strict';

  function cartRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.slice(-1) === '/' ? root : root + '/';
  }

  function getCartDrawerConfig() {
    var drawer = document.querySelector('[data-wevolt-cart-drawer]');
    if (!drawer) return null;
    return {
      sectionId: drawer.dataset.sectionId,
      autoOpen: drawer.dataset.autoOpen === 'true'
    };
  }

  function initProductCard(card) {
    if (!card || card.dataset.wevoltProductCardInit === 'true') return;
    card.dataset.wevoltProductCardInit = 'true';

    var gallery = card.querySelector('[data-wevolt-card-gallery]');
    var showSecondary = gallery && gallery.dataset.showSecondary === 'true';
    var secondaryImage = gallery && gallery.querySelector('.wevolt-product-card__image--secondary');

    if (gallery && showSecondary && secondaryImage) {
      gallery.classList.add('has-secondary');
      gallery.addEventListener('mouseenter', function () {
        gallery.classList.add('is-hovering');
      });
      gallery.addEventListener('mouseleave', function () {
        gallery.classList.remove('is-hovering');
      });
    }

    var quickAddBtns = card.querySelectorAll('[data-wevolt-quick-add]');
    quickAddBtns.forEach(function (quickAddBtn) {
      quickAddBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        addToCart(quickAddBtn, card);
      });
    });
  }

  function showAddError(button, textEl) {
    var errorMsg = button.dataset.errorMsg || 'Could not add to cart';
    button.classList.add('has-error');
    if (textEl) {
      textEl.textContent = errorMsg;
      textEl.hidden = false;
    }
    window.setTimeout(function () {
      button.classList.remove('has-error');
      if (textEl && button.dataset.defaultLabel) textEl.textContent = button.dataset.defaultLabel;
    }, 2500);
  }

  function addToCart(button, card) {
    var variantId = button.dataset.variantId;
    if (!variantId || button.classList.contains('is-loading')) return;

    var textEl = button.querySelector('.wevolt-product-card__quick-add-text');
    var loadingEl = button.querySelector('.wevolt-product-card__quick-add-loading');
    var config = getCartDrawerConfig();

    button.classList.add('is-loading');
    if (textEl) textEl.hidden = true;
    if (loadingEl) loadingEl.hidden = false;

    var body = { items: [{ id: parseInt(variantId, 10), quantity: 1 }] };
    if (config && config.sectionId) {
      body.sections = config.sectionId;
      body.sections_url = cartRoot();
    }

    fetch(cartRoot() + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw data;
          return data;
        });
      })
      .then(function (data) {
        card.classList.add('is-added');

        return fetch(cartRoot() + 'cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var detail = {
              itemCount: cart.item_count,
              sections: data.sections || null
            };

            document.dispatchEvent(new CustomEvent('wevolt:cart:updated', { detail: detail }));

            document.dispatchEvent(
              new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  resource: data,
                  data: { itemCount: cart.item_count, sections: data.sections, source: 'wevolt-card' },
                },
              })
            );

            document.querySelectorAll('.wig-header__cart-count').forEach(function (el) {
              el.textContent = String(cart.item_count);
              el.classList.toggle('is-empty', cart.item_count === 0);
            });

            if (config && config.autoOpen) {
              document.dispatchEvent(new CustomEvent('wevolt:cart:open', { detail: detail }));
            }

            if (window.wevoltCartDrawer) {
              window.wevoltCartDrawer.updateBubbles(cart.item_count);
            }
          });
      })
      .catch(function () {
        showAddError(button, textEl);
      })
      .finally(function () {
        button.classList.remove('is-loading');
        if (loadingEl) loadingEl.hidden = true;
        if (textEl && !button.classList.contains('has-error')) textEl.hidden = false;
      });
  }

  function boot(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-wevolt-product-card]').forEach(initProductCard);
  }

  window.bootWevoltProductCards = boot;

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
})();
